import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import OrderLogUpdate from "./OrderLogUpdate";
import OrderLogAddition from "./OrderLogAddition";
import OrderLogApproval from "./OrderLogApproval";
import OrderLogReview from "./OrderLogReview";
import OrderLogRerun from "./OrderLogRerun";
import OrderLogView from "./OrderLogView";
import OrderLogTrackingInfo from "./OrderLogTrackingInfo";
import InvoiceAddition from "./OrderLogInvoiceAddition";
import InvoiceDeletion from "./OrderLogInvoiceDeletion";
import OrderItemDeletion from "./OrderLogItemDeletion";
import LogTemplate from "../../../../../reusable-components/activity-log/LogTemplate";

OrderLogItem.propTypes = {
  logItem: PropTypes.object,
  setHighlightedRow: PropTypes.func,
  idx: PropTypes.number,
  orderType: PropTypes.string,
}

export default function OrderLogItem({logItem, setHighlightedRow, idx, orderType}) {

  const { id = '' } = useParams();
  const { orderById } = useSelector((state) => state.orders);
  const { items = [] } = orderById[id] || {};

  if (logItem.type === "Update") {
    const orderItem = logItem.itemQuantityId ? items?.find(item => item.id === logItem.itemQuantityId) : null;
    if(!orderItem?.productDetailUOMs){
      logItem.columnChanges = logItem.columnChanges?.filter(change => change.columnName !== "UOMType" && change.columnName !== "UOMAmount")
    }
    const message = <OrderLogUpdate
      logItem={logItem}
      setHighlightedRow={setHighlightedRow}
      orderItem={orderItem}
    />

    return logItem?.columnChanges?.length > 0 && <LogTemplate idx={idx} icon="mdi:update" message={message} />
  } 
  
  if (logItem.type === "Addition") return <LogTemplate
    idx={idx}
    icon="mdi:plus"
    message={<OrderLogAddition logItem={logItem} orderType={orderType} />}
  />;

  if (logItem.type === "Approval") return <LogTemplate
    idx={idx}
    icon="mdi:check"
    message={<OrderLogApproval logItem={logItem} />}
  />;

  if (logItem.type === "Review") return <LogTemplate
    idx={idx}
    icon="mdi:clipboard-check-outline"
    message={<OrderLogReview logItem={logItem} />}
  />;

  if (logItem.type === "View") return <LogTemplate idx={idx} icon="mdi:eye-outline" message={<OrderLogView logItem={logItem} />} />;

  if (logItem.type === "Rerun") return <LogTemplate idx={idx} icon="mdi:restart" message={<OrderLogRerun logItem={logItem} />} />;

  if(logItem.type === "TrackingInfo") return <LogTemplate
    idx={idx}
    icon="mdi:truck"
    message={<OrderLogTrackingInfo logItem={logItem} setHighlightedRow={setHighlightedRow} items={items}/>}
  />;
  
  if(logItem.type === "InvoiceAddition") return <LogTemplate
    idx={idx}
    icon="mdi:receipt-text-plus-outline"
    message={<InvoiceAddition logItem={logItem} setHighlightedRow={setHighlightedRow} items={items}/>}
  />;

  if(logItem.type === "InvoiceDeletion") return <LogTemplate
    idx={idx}
    icon="mdi:receipt-text-remove-outline"
    message={<InvoiceDeletion logItem={logItem}/>}
  />;

  if(logItem.type === "OrderItemDeletion") return <LogTemplate
    idx={idx}
    icon="mdi:delete-outline"
    message={<OrderItemDeletion logItem={logItem} setHighlightedRow={setHighlightedRow}/>}
  />;

}